export enum ConductTypes {
  Swearing = "SWEARING",
  Corruption = "CORRUPTION",
  ViolentConduct = "VIOLENT_CONDUCT",
  MatchFixing = "MATCH_FIXING",
  Citation = "CITATION",
  UnsportsmanlikeConduct = "UNSPORTSMANLIKE_CONDUCT",
  Doping = "DOPING",
  Concussion = "CONCUSSION",
}
